"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Breadcrumb_1 = __importDefault(require("./Breadcrumb"));
exports.default = Breadcrumb_1.default;
